import CaseItemMobile from "./CaseItemMobile";

export default CaseItemMobile;
